module.exports = __webpack_public_path__ + "img/ellipse3.1f42e07.png";